import '../css/FloatingControls.scss'
import { sendData } from '../data/sendData'
import { startRecognition, stopRecognition } from '../scripts/speechChrome'
import { divideText } from '../scripts/text'
import { _hub_exp_thisTask } from './hub'
import { Button } from '@material-ui/core'
import { blue, grey } from '@material-ui/core/colors'
import { ThemeProvider, createTheme } from '@material-ui/core/styles'
import { BackspaceRounded, MicRounded } from '@material-ui/icons'
import 'animate.css'
import PropTypes from 'prop-types'
import React, { Component, createRef } from 'react'
import isEqual from 'react-fast-compare'

const theme = createTheme({
  palette: {
    primary: {
      main: blue[500],
      darker: blue[800],
      contrastText: blue[50],
    },
    secondary: {
      main: grey[500],
      darker: grey[800],
      contrastText: grey[50],
    },
  },
})

export default class FloatingControls extends Component {
  constructor() {
    super()
    this.controlsRef = createRef()
    this.replaceRef = createRef()
    this.deleteRef = createRef()

    this.replaceStart = this._handleReplaceStart.bind(this)
    this.replaceEnd = this._handleReplaceEnd.bind(this)
    this.delete = this._handleDelete.bind(this)

    this.tempResult = this.handleTempResult.bind(this)
    this.finalResult = this.handleFinalResult.bind(this)

    this.speechButtonPressed = { current: false }
  }

  shouldComponentUpdate(prevProps, prevState) {
    return !isEqual(prevProps, this.props) || !isEqual(prevState, this.state)
  }

  componentDidUpdate() {
    this.speechButtonPressed.current = false
  }

  shouldShowControls() {
    return this.props.selectedArray.length !== 0 && !this.props.inSelecting
  }

  buttonClassNames(show) {
    return {
      controls: 'floating-controls' + (show ? ' show' : ' no-show'),
      replace:
        'controls-button replace-button animate__animated' +
        (show ? ' animate__slideInUp' : ' animate__slideOutDown'),
      delete:
        'controls-button delete-button animate__animated' +
        (show ? ' animate__slideInUp' : ' animate__slideOutDown'),
    }
  }

  /* -------------------------------------------------------------------------- */
  /*                             Text Replace Start                             */
  /* -------------------------------------------------------------------------- */

  _handleReplaceStart(e) {
    e.stopPropagation()
    startRecognition(
      this.tempResult,
      this.finalResult,
      this.speechButtonPressed
    )

    const { selectedArray } = this.props
    sendData('speechstart', e, {
      touchSpeed: 0,
      touchTarget: 'speechButton',
      selectionArray: selectedArray,
      textArray: _hub_exp_thisTask.text,
    })

    return false
  }

  handleTempResult(r) {
    // this.props.blockChangeText(this.updateTextArray(r))
    if (r.length && divideText(r).length) this.props.onStartRecognition(r)
  }

  /* -------------------------------------------------------------------------- */
  /*                              Text Replace End                              */
  /* -------------------------------------------------------------------------- */

  _handleReplaceEnd() {
    stopRecognition(this.speechButtonPressed)
    return false
  }

  handleFinalResult(r) {
    const { selectedArray } = this.props
    const newTextArray = this.updateTextArray(r)

    sendData('speechend', null, {
      touchSpeed: 0,
      touchTarget: 'speechButton',
      selectionArray: selectedArray,
      textArray: newTextArray,
    })

    this.props.bodyChangeText(newTextArray)
  }

  updateTextArray(r) {
    const { textArray, selectedArray } = this.props
    let tA = [...textArray]
    let newArray = divideText(r)

    if (
      newArray[newArray.length - 1] &&
      selectedArray[selectedArray.length - 1]
    )
      newArray[newArray.length - 1][1] =
        selectedArray[selectedArray.length - 1][1]

    // Remove punctuation for one word
    // if (newArray.length === 2) {
    //   newArray[1][0] = ''
    // }

    // Remove punctuation for end of sentence
    // if (
    //   selectedArray.length &&
    //   tA[selectedArray[selectedArray.length - 1][2] + 1] &&
    //   ['?', '.', ',', '!'].includes(
    //     tA[selectedArray[selectedArray.length - 1][2] + 1][0]
    //   )
    // ) {
    //   newArray[newArray.length - 1][0] = ''
    // }

    // Lowercase the first word of recognition
    // if (
    //   selectedArray.length &&
    //   selectedArray[0].length &&
    //   selectedArray[0][0].length &&
    //   /[a-z]/.test(selectedArray[0][0][0])
    // ) {
    //   newArray[0][0] = newArray[0][0].toLowerCase()
    // }

    if (selectedArray.length)
      tA.splice(
        selectedArray[0][2],
        selectedArray[selectedArray.length - 1][2] - selectedArray[0][2] + 1,
        ...newArray
      )

    return tA
  }

  /* -------------------------------------------------------------------------- */
  /*                                   Delete                                   */
  /* -------------------------------------------------------------------------- */

  _handleDelete(e) {
    const { textArray, selectedArray, bodyChangeText } = this.props
    let tA = [...textArray]

    tA.splice(
      selectedArray[0][2],
      selectedArray[selectedArray.length - 1][2] - selectedArray[0][2] + 1
    )

    bodyChangeText(tA)

    sendData('deleteblock', e, {
      touchSpeed: 0,
      touchTarget: 'deleteButton',
      selectionArray: selectedArray,
      text: tA,
    })

    return false
  }

  render() {
    const show = this.shouldShowControls()
    const classes = this.buttonClassNames(show)

    return (
      <ThemeProvider theme={theme}>
        <div className={classes.controls} ref={this.controlsRef}>
          <Button
            key="replace-button"
            ref={this.replaceRef}
            className={classes.replace}
            variant="contained"
            startIcon={
              <MicRounded
                sx={{
                  fill: blue[50],
                }}
              />
            }
            size="large"
            disableElevation
            onTouchStart={this.replaceStart}
            onTouchEnd={this.replaceEnd}
            onContextMenu={e => {
              e.preventDefault()
            }}
          >
            Speak
          </Button>
          <Button
            key="delete-button"
            ref={this.deleteRef}
            className={classes.delete}
            variant="contained"
            color="secondary"
            size="large"
            disableElevation
            onClick={this.delete}
          >
            <BackspaceRounded
              sx={{
                fill: grey[50],
              }}
            />
          </Button>
        </div>
      </ThemeProvider>
    )
  }
}

FloatingControls.propTypes = {
  textArray: PropTypes.array,
  selectedArray: PropTypes.array,
  inSelecting: PropTypes.bool,
  blockRef: PropTypes.object,
  bodyChangeText: PropTypes.func,
  onStartRecognition: PropTypes.func,
  onEndRecognition: PropTypes.func,
}
